import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProyectosService } from '../../../services/proyectos.service';

@Component({
  selector: 'app-linea-amarilla',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './linea-amarilla.html',
  styleUrl: './linea-amarilla.css'
})
export class LineaAmarillaComponent implements OnInit {
  proyectosRecomendados: any[] = [];

  constructor(private proyectosService: ProyectosService) {}

  ngOnInit() {
    this.proyectosRecomendados = this.proyectosService.getProyectosAleatorios('/proyectos/linea-amarilla');
  }
}
